import { useState } from "react";
import { PartyPopper, Undo2, Loader2 } from "lucide-react";
import { api, errText, photoUrl } from "../lib/api";
import { useLanguage } from "../context/LanguageContext";
import { toast } from "sonner";

export const ReunitedBanner = ({ listing }) => {
  const { t } = useLanguage();
  if (!listing.reunited_at) return null;
  const story = listing.reunion_story;
  return (
    <div data-testid="reunited-banner" className="mb-5 relative overflow-hidden rounded-2xl bg-gradient-to-r from-emerald-600 to-teal-500 text-white px-6 py-5 flex items-center gap-4">
      <div className="absolute -right-8 -top-8 h-36 w-36 rounded-full bg-white/10" />
      <div className="absolute right-20 -bottom-10 h-24 w-24 rounded-full bg-white/10" />
      <span className="h-12 w-12 shrink-0 rounded-2xl bg-white/20 flex items-center justify-center animate-bounce"><PartyPopper size={26} /></span>
      <div className="relative flex-1">
        <p className="font-display text-xl sm:text-2xl font-extrabold">{t("lfr_banner_title")}</p>
        <p className="text-white/85 text-sm mt-0.5">{t("lfr_banner_sub")}</p>
        {story?.note && <p className="mt-2 text-white italic text-sm sm:text-base max-w-2xl" data-testid="reunited-banner-note">“{story.note}”</p>}
      </div>
      {story?.photo && <img src={photoUrl(story.photo)} alt="" data-testid="reunited-banner-photo" className="relative h-24 w-24 sm:h-28 sm:w-28 rounded-2xl object-cover border-4 border-white/40 shrink-0 rotate-2 shadow-lg" />}
    </div>
  );
};

export const ReunitedButton = ({ listing, onChange }) => {
  const { t } = useLanguage();
  const [busy, setBusy] = useState(false);
  const on = !!listing.reunited_at;
  const toggle = async () => {
    if (!on && !window.confirm(t("lfr_confirm"))) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/listings/${listing.id}/reunited`, { reunited: !on });
      onChange(data.reunited_at);
      if (!on) toast.success(t("lfr_done"));
    } catch (e) { toast.error(errText(e)); }
    finally { setBusy(false); }
  };
  return (
    <button onClick={toggle} disabled={busy} data-testid={on ? "unmark-reunited-btn" : "mark-reunited-btn"}
      className={`mt-4 inline-flex items-center gap-2 h-11 px-5 rounded-xl font-semibold text-sm transition-colors disabled:opacity-60 ${on ? "border border-slate-200 text-slate-600 hover:border-slate-300" : "bg-emerald-600 hover:bg-emerald-700 text-white"}`}>
      {busy ? <Loader2 size={16} className="animate-spin" /> : on ? <Undo2 size={16} /> : <PartyPopper size={16} />}
      {on ? t("lfr_unmark") : t("lfr_mark")}
    </button>
  );
};
